import { render, staticRenderFns } from "./RecessLineElement.vue?vue&type=template&id=00edbda0&scoped=true"
import script from "./RecessLineElement.vue?vue&type=script&lang=js"
export * from "./RecessLineElement.vue?vue&type=script&lang=js"
import style0 from "./RecessLineElement.vue?vue&type=style&index=0&id=00edbda0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00edbda0",
  null
  
)

export default component.exports